import { render, staticRenderFns } from "./applyAftersales.vue?vue&type=template&id=4ca22cd9&scoped=true&"
import script from "./applyAftersales.vue?vue&type=script&lang=js&"
export * from "./applyAftersales.vue?vue&type=script&lang=js&"
import style0 from "./applyAftersales.vue?vue&type=style&index=0&id=4ca22cd9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca22cd9",
  null
  
)

export default component.exports